import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const LOGO = "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/nvlni4cj_website%20photo%20twp.png";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Services' },
    { to: '/about', label: 'About' },
    { to: '/retreat', label: 'Retreat' },
  ];

  return (
    <nav
      data-testid="navigation"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled ? 'rgba(247,244,239,0.96)' : 'transparent',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        boxShadow: scrolled ? '0 1px 24px rgba(43,43,43,0.06)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex-shrink-0">
          <span
            className="font-serif text-xl sm:text-2xl"
            style={{ color: '#2B2B2B', letterSpacing: '0.02em' }}
          >
            Resonant Healing
          </span>
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className="text-sm font-medium transition-colors duration-200"
              style={{
                color: location.pathname === link.to ? '#7E8C74' : 'rgba(43,43,43,0.65)',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://forms.gle/acnQmapg39FqW7wL7"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-apply-btn"
            className="rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
            style={{ background: '#A8B5A2', color: '#2B2B2B', padding: '10px 26px' }}
          >
            Apply
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-btn"
          className="md:hidden p-2 flex flex-col justify-center gap-1.5"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span
            className="block w-6 h-px transition-all duration-300"
            style={{ background: '#2B2B2B', transform: mobileOpen ? 'rotate(45deg) translateY(5px)' : 'none' }}
          />
          <span
            className="block w-6 h-px transition-all duration-300"
            style={{ background: '#2B2B2B', opacity: mobileOpen ? 0 : 1 }}
          />
          <span
            className="block w-6 h-px transition-all duration-300"
            style={{ background: '#2B2B2B', transform: mobileOpen ? 'rotate(-45deg) translateY(-5px)' : 'none' }}
          />
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden px-6 py-8 space-y-5"
          style={{ background: '#F7F4EF', borderTop: '1px solid #EAE3D9' }}
        >
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              className="block text-base py-1"
              style={{ color: location.pathname === link.to ? '#7E8C74' : '#2B2B2B' }}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://forms.gle/acnQmapg39FqW7wL7"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-apply-btn"
            className="block text-center rounded-full text-sm font-medium mt-2"
            style={{ background: '#A8B5A2', color: '#2B2B2B', padding: '13px 24px' }}
          >
            Apply to Work Together
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
